// Client for /api/memory (backend/chainlit/memory_api.py): what the company
// has told Signals. The server decides who may change what; this file only
// carries it.

export interface MemoryFact {
  id: number;
  fact: string;
  by: string | null;
  at: string;
  active: boolean; // false = the data disagrees, so it stopped applying
  last_used_at: string | null;
}

export interface MemoryProposal {
  id: number;
  fact: string;
  by: string | null;
  at: string;
  mine: boolean;
}

export interface MemoryState {
  can_manage: boolean;
  facts: MemoryFact[];
  proposals: MemoryProposal[];
  approvals_ready: boolean;
  max_active: number;
}

async function call<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export const getMemory = () => call<MemoryState>('/api/memory');

export const addMemory = (fact: string) =>
  call<{ status: 'active' | 'pending'; id: number }>('/api/memory', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fact })
  });

export const reviewProposal = (id: number, decision: 'approve' | 'reject') =>
  call<{ status: string }>(`/api/memory/proposals/${id}/${decision}`, {
    method: 'POST'
  });

export const withdrawProposal = (id: number) =>
  call<{ status: string }>(`/api/memory/proposals/${id}`, { method: 'DELETE' });

export const forgetFact = (id: number) =>
  call<{ status: string }>(`/api/memory/${id}`, { method: 'DELETE' });
